/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */

'use strict';

var EntryPointContainer = require('./relay-hooks/EntryPointContainer.react');
var loadEntryPoint = require('./relay-hooks/loadEntryPoint');
var _require = require('./relay-hooks/loadQuery'),
  loadQuery = _require.loadQuery;
var ProfilerContext = require('./relay-hooks/ProfilerContext');
var RelayEnvironmentProvider = require('./relay-hooks/RelayEnvironmentProvider');
var useEntryPointLoader = require('./relay-hooks/useEntryPointLoader');
var useFragment = require('./relay-hooks/useFragment');
var useLazyLoadQuery = require('./relay-hooks/useLazyLoadQuery');
var useMutation = require('./relay-hooks/useMutation');
var usePaginationFragment = require('./relay-hooks/usePaginationFragment');
var usePreloadedQuery = require('./relay-hooks/usePreloadedQuery');
var useQueryLoader = require('./relay-hooks/useQueryLoader');
var useRefetchableFragment = require('./relay-hooks/useRefetchableFragment');
var useRelayEnvironment = require('./relay-hooks/useRelayEnvironment');
var useSubscribeToInvalidationState = require('./relay-hooks/useSubscribeToInvalidationState');
var useSubscription = require('./relay-hooks/useSubscription');
var RelayRuntime = require('relay-runtime');
/**
 * The public interface for Relay Hooks.
 * This will eventually become the main public interface for react-relay.
 */
module.exports = {
  ConnectionHandler: RelayRuntime.ConnectionHandler,
  applyOptimisticMutation: RelayRuntime.applyOptimisticMutation,
  commitLocalUpdate: RelayRuntime.commitLocalUpdate,
  commitMutation: RelayRuntime.commitMutation,
  graphql: RelayRuntime.graphql,
  readInlineData: RelayRuntime.readInlineData,
  requestSubscription: RelayRuntime.requestSubscription,
  EntryPointContainer: EntryPointContainer,
  RelayEnvironmentProvider: RelayEnvironmentProvider,
  ProfilerContext: ProfilerContext,
  fetchQuery: RelayRuntime.fetchQuery,
  loadQuery: loadQuery,
  loadEntryPoint: loadEntryPoint,
  useFragment: useFragment,
  useLazyLoadQuery: useLazyLoadQuery,
  useEntryPointLoader: useEntryPointLoader,
  useQueryLoader: useQueryLoader,
  useMutation: useMutation,
  usePaginationFragment: usePaginationFragment,
  usePreloadedQuery: usePreloadedQuery,
  useRefetchableFragment: useRefetchableFragment,
  useRelayEnvironment: useRelayEnvironment,
  useSubscribeToInvalidationState: useSubscribeToInvalidationState,
  useSubscription: useSubscription
};